import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const uv = {
    jpath: ['spectra', 'uv'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default uv;
//# sourceMappingURL=uv.js.map